import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DStringComponent } from './d-string/d-string.component';
import { DTextareaComponent } from './d-textarea/d-textarea.component';
import { DNumberComponent } from './d-number/d-number.component';
import { DRadioComponent } from './d-radio/d-radio.component';
import { DCheckboxComponent } from './d-checkbox/d-checkbox.component';
import { DSelectComponent } from './d-select/d-select.component';
import { DDateComponent } from './d-date/d-date.component';
import { DDateRangeComponent } from './d-date-range/d-date-range.component';
import { DStringConfigComponent } from './d-string-config/d-string-config.component';
import { DTextareaConfigComponent } from './d-textarea-config/d-textarea-config.component';
import { DRadioConfigComponent } from './d-radio-config/d-radio-config.component';
import { DCheckboxConfigComponent } from './d-checkbox-config/d-checkbox-config.component';
import { DNumberConfigComponent } from './d-number-config/d-number-config.component';
import { DDateConfigComponent } from './d-date-config/d-date-config.component';
import { DDateRangeConfigComponent } from './d-date-range-config/d-date-range-config.component';
import { DSelectConfigComponent } from './d-select-config/d-select-config.component';
import { GDatePipe } from './d-date/date-pipe.pipe';
import { GDateRangePipe } from './d-date-range/date-range-pipe.pipe';
import { DConNumberDecimalComponent } from './d-con-number-decimal/d-con-number-decimal.component';
import { DConNumberFloatComponent } from './d-con-number-float/d-con-number-float.component';
import { DConNumberIntegerComponent } from './d-con-number-integer/d-con-number-integer.component';
import { DConNumberDecimalConfigComponent } from './d-con-number-decimal-config/d-con-number-decimal-config.component';
import { DConNumberFloatConfigComponent } from './d-con-number-float-config/d-number-float-config.component';
import { DConNumberIntegerConfigComponent } from './d-con-number-integer-config/d-con-number-integer-config.component';
import { DConStringComponent } from './d-con-string/d-con-string.component';
import { DConStringConfigComponent } from './d-con-string-config/d-con-string-config.component';
import { DConBooleanConfigComponent } from './d-con-boolean-config/d-con-boolean-config.component';
import { DConBooleanComponent } from './d-con-boolean/d-con-boolean.component';
import { DConFixedConfigComponent } from './d-con-fixed-config/d-con-fixed-config.component';
import { DConFixedComponent } from './d-con-fixed/d-con-fixed.component';
import { DConTimestampConfigComponent } from './d-con-timestamp-config/d-con-timestamp-config.component';
import { DConTimestampComponent } from './d-con-timestamp/d-con-timestamp.component';
import { DTitleComponent } from './d-title/d-title.component';
import { DTitleConfigComponent } from './d-title-config/d-title-config.component';

import { DGroupsConfigComponent } from './d-groups-config/d-groups-config.component';
import { DGroupsComponent } from './d-groups/d-groups.component';

import { DImageComponent } from './d-image/d-image.component';
import { DImageConfigComponent } from './d-image-config/d-image-config.component';
import { DSharedModule } from '../../shared';
import { DynamicComponentModule, DynamicComponentRegistryService } from '../../dynamic-component';
import { SHARED_ZORRO_MODULES } from '../../shared-zorro.module';
import { SHARED_DELON_MODULES } from '../../shared-delon.module';
import { DUeditorComponent } from './d-ueditor/d-ueditor.component';
import { DUeditorConfigComponent } from './d-ueditor-config/d-ueditor-config.component';
import { DTextComponent } from './d-text/d-text.component';
import { DTextConfigComponent } from './d-text-config/d-text-config.component';
import { DUploadfileComponent } from './d-uploadfile/d-uploadfile.component';
import { DUploadfileConfigComponent } from './d-uploadfile-config/d-uploadfile-config.component';
import { DSplitlineComponent } from './d-splitline/d-splitline.component';
import { DSplitlineConfigComponent } from './d-splitline-config/d-splitline-config.component';
import { DSliderConfigComponent } from './d-slider-config/d-slider-config.component';
import { DSliderComponent } from './d-slider/d-slider.component';
import { DRateConfigComponent } from './d-rate-config/d-rate-config.component';
import { DRateComponent } from './d-rate/d-rate.component';
import { DColorpickerConfigComponent } from './d-colorpicker-config/d-colorpicker-config.component';
import { DColorpickerComponent } from './d-colorpicker/d-colorpicker.component';
import { ColorPickerModule } from 'ngx-color-picker';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    DynamicComponentModule,
    DSharedModule,
    ColorPickerModule
  ],
  declarations: [
    DStringComponent,
    DTextareaComponent,
    DNumberComponent,

    DRadioComponent,
    DCheckboxComponent,
    DSelectComponent,
    DDateComponent,
    DDateRangeComponent,
    DStringConfigComponent,
    DTextareaConfigComponent,
    DRadioConfigComponent,
    DCheckboxConfigComponent,
    DNumberConfigComponent,
    DImageComponent,

    DDateConfigComponent,
    DDateRangeConfigComponent,
    DSelectConfigComponent,
    DTitleComponent,
    DGroupsComponent,

    DConStringComponent,
    DConNumberDecimalComponent,
    DConNumberFloatComponent,
    DConNumberIntegerComponent,
    DConFixedComponent,
    DConBooleanComponent,
    DConStringConfigComponent,
    DConNumberDecimalConfigComponent,
    DConNumberFloatConfigComponent,
    DConNumberIntegerConfigComponent,
    DConFixedConfigComponent,
    DConBooleanConfigComponent,
    DConTimestampComponent,
    DConTimestampConfigComponent,
    DImageConfigComponent,

    DTitleConfigComponent,
    DGroupsConfigComponent,

    DUeditorComponent,
    DUeditorConfigComponent,
    DTextComponent,
    DTextConfigComponent,
    DUploadfileComponent,
    DUploadfileConfigComponent,
    DSplitlineComponent,
    DSplitlineConfigComponent,
    DSliderComponent,
    DSliderConfigComponent,
    DRateComponent,
    DRateConfigComponent,
    DColorpickerComponent,
    DColorpickerConfigComponent,

    GDatePipe,
    GDateRangePipe
  ],
  exports: []
})
export class WidgetFormControlsModule {
  constructor(registryService: DynamicComponentRegistryService) {
    // 控件注册
    registryService.setDefault(DStringComponent);
    registryService.register(DStringComponent.KEY, DStringComponent);
    registryService.register(DTextareaComponent.KEY, DTextareaComponent);
    registryService.register(DNumberComponent.KEY, DNumberComponent);
    registryService.register(DRadioComponent.KEY, DRadioComponent);
    registryService.register(DCheckboxComponent.KEY, DCheckboxComponent);
    registryService.register(DSelectComponent.KEY, DSelectComponent);
    registryService.register(DDateComponent.KEY, DDateComponent);
    registryService.register(DDateRangeComponent.KEY, DDateRangeComponent);
    registryService.register(DTitleComponent.KEY, DTitleComponent);
    registryService.register(DGroupsComponent.KEY, DGroupsComponent);

    registryService.register(DConStringComponent.KEY, DConStringComponent);
    registryService.register(DConNumberDecimalComponent.KEY, DConNumberDecimalComponent);
    registryService.register(DConNumberFloatComponent.KEY, DConNumberFloatComponent);
    registryService.register(DConNumberIntegerComponent.KEY, DConNumberIntegerComponent);
    registryService.register(DConFixedComponent.KEY, DConFixedComponent);
    registryService.register(DConBooleanComponent.KEY, DConBooleanComponent);
    registryService.register(DConTimestampComponent.KEY, DConTimestampComponent);
    registryService.register(DImageComponent.KEY, DImageComponent);

    // 控件配置器
    registryService.register(DStringConfigComponent.KEY, DStringConfigComponent);
    registryService.register(DTextareaConfigComponent.KEY, DTextareaConfigComponent);
    registryService.register(DNumberConfigComponent.KEY, DNumberConfigComponent);
    registryService.register(DRadioConfigComponent.KEY, DRadioConfigComponent);
    registryService.register(DCheckboxConfigComponent.KEY, DCheckboxConfigComponent);
    registryService.register(DSelectConfigComponent.KEY, DSelectConfigComponent);
    registryService.register(DDateConfigComponent.KEY, DDateConfigComponent);
    registryService.register(DDateRangeConfigComponent.KEY, DDateRangeConfigComponent);
    registryService.register(DTitleConfigComponent.KEY, DTitleConfigComponent);

    registryService.register(DConStringConfigComponent.KEY, DConStringConfigComponent);
    registryService.register(DConNumberDecimalConfigComponent.KEY, DConNumberDecimalConfigComponent);
    registryService.register(DConNumberFloatConfigComponent.KEY, DConNumberFloatConfigComponent);
    registryService.register(DConNumberIntegerConfigComponent.KEY, DConNumberIntegerConfigComponent);
    registryService.register(DConFixedConfigComponent.KEY, DConFixedConfigComponent);
    registryService.register(DConBooleanConfigComponent.KEY, DConBooleanConfigComponent);
    registryService.register(DConTimestampConfigComponent.KEY, DConTimestampConfigComponent);
    registryService.register(DGroupsConfigComponent.KEY, DGroupsConfigComponent);
    registryService.register(DImageConfigComponent.KEY, DImageConfigComponent);

    registryService.register(DUeditorComponent.KEY, DUeditorComponent);
    registryService.register(DUeditorConfigComponent.KEY, DUeditorConfigComponent);
    registryService.register(DTextComponent.KEY, DTextComponent);
    registryService.register(DTextConfigComponent.KEY, DTextConfigComponent);
    registryService.register(DUploadfileComponent.KEY, DUploadfileComponent);
    registryService.register(DUploadfileConfigComponent.KEY, DUploadfileConfigComponent);
    registryService.register(DSplitlineComponent.KEY, DSplitlineComponent);
    registryService.register(DSplitlineConfigComponent.KEY, DSplitlineConfigComponent);
    registryService.register(DSliderComponent.KEY, DSliderComponent);
    registryService.register(DSliderConfigComponent.KEY, DSliderConfigComponent);
    registryService.register(DRateComponent.KEY, DRateComponent);
    registryService.register(DRateConfigComponent.KEY, DRateConfigComponent);
    registryService.register(DColorpickerComponent.KEY, DColorpickerComponent);
    registryService.register(DColorpickerConfigComponent.KEY, DColorpickerConfigComponent);
  }
}
